@import "navigation-mixins";
@import "navigation-item";

.ux-iws-nav {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        align-items: flex-end;
        position: relative;
    }
}

.ux-iws-nav__lvl1 {
    width: 100%;
    left: 0;
    top: -9999vh;
    margin: 0;
    padding: 15px 30px;
    background: $color-white;
    position: absolute;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        margin-bottom: 16px;
        padding: 0;
        left: auto;
        top: auto;
        width: auto;
        display: flex;
        position: relative;
    }

    .ux-iws-nav--active .ux-iws-nav__lvl2 {
        display: block;

        /* stylelint-disable selector-max-compound-selectors */
        @media only screen and (min-width: $desktop-s-navigation-100) {
            visibility: visible;
        }

        /* stylelint-enable selector-max-compound-selectors */
    }

    &--active {
        top: 100px;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            top: auto;
        }
    }
}

.ux-iws-nav__lvl2,
.ux-iws-nav__lvl3,
.ux-iws-nav__lvl4 {
    cursor: default;
    background: $color-white;
}

.ux-iws-nav__lvl2 {
    left: 0;
    top: 0;
    width: 100%;
    max-width: 1920px;
    padding: 60px 30px 30px;
    position: absolute;
    display: none;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        left: 50%;
        transform: translateX(-50%);
        padding: 30px 0 0;
        top: 100px;
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
        display: block;
        visibility: hidden;
        position: fixed;
        z-index: 1;
    }

    &::before,
    &::after {
        content: "";
        top: -100px;
        width: 12px;
        height: calc(100% + 100px);
        background: $color-white;
        position: absolute;
    }

    &::before {
        left: -11px;
    }

    &::after {
        right: -11px;
    }

    .ux-iws-nav--not-active {
        display: none;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: block;
        }
    }

    .ux-iws-nav--active .ux-iws-nav__lvl3-wrapper {
        display: flex;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            visibility: visible;
        }
    }

    /* stylelint-disable selector-max-compound-selectors */
    .ux-iws-nav--active
        .ux-iws-nav__lvl3-item.ux-iws-nav--active
        .ux-iws-nav__lvl4-wrapper {
        display: flex;
        /* stylelint-enable selector-max-compound-selectors */

        @media only screen and (min-width: $desktop-s-navigation-100) {
            visibility: visible;
        }
    }

    .ux-iws-nav__lvl2-item-toolbox {
        margin: 0 -30px;
        list-style: none;

        @media (min-width: 1024px) {
            margin: 0;
        }
    }
}

.ux-iws-nav__lvl3-wrapper,
.ux-iws-nav__lvl4-wrapper {
    background: $color-white;
    position: absolute;
    padding: 60px 30px 30px;
    display: flex;
    flex-direction: column;
    z-index: 11;
    display: none;
    cursor: default;

    @media only screen and (min-width: $tablet) {
        flex-flow: row wrap;
    }

    @media only screen and (min-width: $desktop-xl) {
        left: 31%;
    }
}

.ux-iws-nav__lvl3-wrapper {
    left: 0;
    top: 0;
    width: 100%;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        left: 34%;
        width: 20%;
        padding: 0;
        display: flex;
        visibility: hidden;
        position: fixed;
    }
}

.ux-iws-nav__lvl4-wrapper {
    left: -30px;
    right: -30px;
    top: -60px;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        left: 34%;
        top: 0;
        right: auto;
        width: 20%;
        padding: 0;
        display: flex;
        visibility: hidden;
        position: fixed;
    }
}

.ux-iws-nav__lvl3,
.ux-iws-nav__lvl4 {
    width: 100%;
    margin: 0;
    padding: 0;
    position: relative;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        width: 50%;
        position: fixed;
        padding: 30px 0 35px;
        background: transparent;

        &:nth-of-type(1)::before {
            content: "";
            width: 1px;
            height: 100%;
            left: 0;
            top: 0;
            border-right: 1px solid $border-color;
            position: absolute;
            z-index: 1;
        }
    }
}

.ux-iws-nav__lvl3 {
    @media only screen and (min-width: $desktop-s-navigation-100) {
        &:nth-of-type(1) {
            left: 28%;
            width: 24%;
        }

        &:nth-of-type(2) {
            left: 52%;
            width: 24%;
        }

        &:nth-of-type(3) {
            left: 76%;
            width: 24%;
        }
    }

    @media only screen and (min-width: $desktop-l) {
        &:nth-of-type(1) {
            left: 34%;
            width: 22%;
        }

        &:nth-of-type(2) {
            left: 56%;
            width: 22%;
        }

        &:nth-of-type(3) {
            left: 78%;
            width: 22%;
        }
    }

    @media only screen and (min-width: $desktop-xl) {
        &:nth-of-type(1) {
            left: 31%;
            width: 23%;
        }

        &:nth-of-type(2) {
            left: 54%;
            width: 23%;
        }

        &:nth-of-type(3) {
            left: 77%;
            width: 23%;
        }
    }
}

// lvl4
.ux-iws-nav__lvl4 {
    @media only screen and (min-width: $desktop-s-navigation-100) {
        &:nth-of-type(1) {
            left: 52%;
            width: 24%;
        }

        &:nth-of-type(2) {
            left: 76%;
            width: 24%;
        }
    }

    @media only screen and (min-width: $desktop-l) {
        &:nth-of-type(1) {
            left: 56%;
            width: 22%;
        }

        &:nth-of-type(2) {
            left: 78%;
            width: 22%;
        }
    }

    @media only screen and (min-width: $desktop-xl) {
        &:nth-of-type(1) {
            left: 54%;
            width: 23%;
        }

        &:nth-of-type(2) {
            left: 77%;
            width: 23%;
        }
    }
}

/* stylelint-disable selector-max-compound-selectors */
.ux-iws-nav__lvl3-wrapper--has-overview-links .ux-iws-nav__lvl3,
.ux-iws-nav__lvl4-wrapper--has-overview-links .ux-iws-nav__lvl4 {
    @media only screen and (min-width: $tablet) {
        padding-top: 52px;

        &:nth-of-type(3) {
            padding-top: 0;
        }
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        padding-top: 83px;

        &:nth-of-type(3) {
            padding-top: 83px;
        }
    }
}
/* stylelint-enable selector-max-compound-selectors */

.ux-iws-nav__meta {
    display: flex;
    align-items: center;

    .ux-iws-nav__meta-container-header {
        margin-right: 10px;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            right: -20px;
            top: 0;
            margin: 0;
            position: absolute;
            max-width: calc(100% + 40px);
            overflow-x: scroll;
            padding: 0 20px 15px;
            //hide horizontal scrollbar
            -ms-overflow-style: none;
            scrollbar-width: none;
        }
    }

    .ux-iws-nav__meta-container-header::-webkit-scrollbar {
        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: none;
        }
    }
}

.ux-iws-nav__eyecatcher {
    left: 130px;
    bottom: 0;
    padding: 3px 15px 4px;
    background: $color-green;
    position: absolute;
    cursor: default;

    @media only screen and (min-width: $tablet) {
        left: 150px;
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        left: auto;
        right: 0;
    }

    span {
        color: $color-white;
    }

    .ux-iws-header--active & {
        display: none;
    }

    .ux-iws-header--100 & {
        background: $color-blue-highlight-1;
        left: 200px;
        white-space: nowrap;

        @media only screen and (max-width: 374px) {
            display: none;
        }

        @media only screen and (min-width: $tablet) {
            left: 280px;
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            left: auto;
            right: 0;
        }
    }
}

.ux-iws-nav__lvl2-back,
.ux-iws-nav__lvl3-back,
.ux-iws-nav__lvl4-back {
    @include font(bold);
    left: 30px;
    top: 30px;
    font-size: $size-text-small;
    display: block;
    margin: 0 0 20px;
    text-transform: uppercase;
    position: absolute;
    transition: color 0.2s ease-in-out;
    cursor: pointer;

    &::before {
        content: "← ";
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        display: none;
    }

    &:hover {
        color: $color-green;
    }
}
